import {DomainService, WinForm} from "../libs"
import {AuthService} from "../service"

// @ts-ignore
const loginUserId: any = AuthService.user().userId;

export class ChatService {
  /**
   * 打开聊天对话
   * @param categoryId
   * @param userId
   * @constructor
   */
  static StartRecent(categoryId: number, userId: string) {
    if (userId == loginUserId) return;
    WinForm.md.$emit("IMStart", `${categoryId}:${userId}`);
    (parent.window as any || window as any).md.openChatTab();
  }

  // 打开人员信息页面
  static openUserInfo(userId: string) {
    // let url = `${location.protocol}//${DomainService.Sjb}/views/userinfo.html?userId=${userId}`
    // WinForm.md.openWindow(url, 314, 480);
  }

}